export default __webpack_public_path__ + "static/media/img1.db6120d0.jpg";